(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-card"] && !Shopify.designMode) return;
  try {
    class CollabGallery extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleThumbnailClick);
    }

    handleThumbnailClick(event) {
      const thumbnail = event.target.closest('[data-collab-thumbnail]');
      if (!thumbnail) return;

      const mainImage = this.querySelector('[data-collab-main-image]');
      if (!mainImage) return;

      mainImage.src = thumbnail.dataset.fullSrc;
      mainImage.srcset = thumbnail.dataset.fullSrcset;
      mainImage.width = thumbnail.dataset.fullWidth;
      mainImage.height = thumbnail.dataset.fullHeight;
      mainImage.alt = thumbnail.dataset.fullAlt;
    }
  }

  if (!customElements.get('collab-gallery')) {
    customElements.define('collab-gallery', CollabGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
